import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import TopNav from '../components/TopNav';
import BottomNav from '../components/BottomNav';

const Lookbook = () => {
  const [collections, setCollections] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [collectionProducts, setCollectionProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(false);

  useEffect(() => {
    loadCollections();
  }, []);

  const loadCollections = async () => {
    try {
      const data = await api.getLookbookCollections();
      setCollections(data);
    } catch (error) {
      console.error('Error loading collections:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCollectionClick = async (collectionId) => {
    setLoadingProducts(true);
    try {
      const data = await api.getLookbookCollection(collectionId);
      setSelectedCollection(data);
      setCollectionProducts(data.products || []);
    } catch (error) {
      console.error('Error loading collection details:', error);
    } finally {
      setLoadingProducts(false);
    }
  };

  const handleBackToCollections = () => {
    setSelectedCollection(null);
    setCollectionProducts([]);
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TopNav />
        <p style={{ color: '#4C956C' }}>LOADING...</p>
        <BottomNav currentPath="/lookbook" />
      </div>
    );
  }

  // Detail view - showing products in a collection
  if (selectedCollection) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', paddingBottom: '100px' }}>
        <TopNav currentPath="/lookbook" />
        
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
          {/* Back button */}
          <button
            onClick={handleBackToCollections}
            className="retro-btn"
            style={{
              background: '#FFF',
              color: '#2C6E49',
              border: '2px solid #2C6E49',
              padding: '10px 20px',
              fontSize: '11px',
              marginBottom: '20px',
              fontWeight: 'bold'
            }}
          >
            ← BACK TO COLLECTIONS
          </button>

          {/* Collection Header */}
          <div className="retro-card" style={{ background: selectedCollection.banner_color || '#2C6E49', padding: '40px', textAlign: 'center', marginBottom: '30px' }}>
            <div style={{ fontSize: '64px', marginBottom: '15px' }}>
              {selectedCollection.emoji_icons?.join(' ') || '⛳'}
            </div>
            <h1 style={{ fontSize: '28px', color: '#FEFEE3', marginBottom: '10px', fontWeight: 'bold' }}>{selectedCollection.name}</h1>
            <p style={{ fontSize: '14px', color: '#FFC857', marginBottom: '15px' }}>{selectedCollection.season}</p>
            <p style={{ fontSize: '13px', color: '#FEFEE3', lineHeight: '1.6', maxWidth: '600px', margin: '0 auto' }}>{selectedCollection.description}</p>
            <p style={{ fontSize: '12px', color: '#FFC857', marginTop: '20px' }}>{collectionProducts.length} PIECES IN THIS COLLECTION</p>
          </div>

          {/* Products Grid */}
          {loadingProducts ? (
            <p style={{ textAlign: 'center', color: '#4C956C' }}>LOADING PRODUCTS...</p>
          ) : collectionProducts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p style={{ color: '#4C956C', fontSize: '14px' }}>NO PRODUCTS IN THIS COLLECTION YET</p>
              <p style={{ color: '#999', fontSize: '12px', marginTop: '10px' }}>Add products from the admin panel</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
              {collectionProducts.map((product) => {
                const displayImage = product.variants && product.variants[0] && product.variants[0].image_url
                  ? product.variants[0].image_url
                  : (product.images && product.images[0] ? product.images[0] : null);

                return (
                  <Link
                    key={product._id}
                    to={`/product/${product._id}`}
                    className="retro-card"
                    style={{
                      textDecoration: 'none',
                      background: '#FFF',
                      padding: '15px',
                      transition: 'transform 0.2s'
                    }}
                  >
                    <div style={{
                      background: product.bg_color || '#F7F6D8',
                      border: '2px solid #000',
                      aspectRatio: '1',
                      marginBottom: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden'
                    }}>
                      {displayImage ? (
                        <img src={displayImage} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <span style={{ fontSize: '48px' }}>👕</span>
                      )}
                    </div>
                    <h3 style={{ fontSize: '13px', color: '#2C6E49', marginBottom: '5px', fontWeight: 'bold' }}>{product.name}</h3>
                    <p style={{ fontSize: '11px', color: '#4C956C', marginBottom: '5px' }}>{product.category}</p>
                    <p style={{ fontSize: '15px', color: '#2C2C2C', fontWeight: 'bold' }}>${product.base_price?.toFixed(2)}</p>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
        
        <BottomNav currentPath="/lookbook" />
      </div>
    );
  }

  // List view - showing all collections
  return (
    <div style={{ minHeight: '100vh', background: '#FEFEE3', paddingBottom: '100px' }}>
      <TopNav currentPath="/lookbook" />
      
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <h1 style={{ fontSize: '24px', color: '#2C6E49', marginBottom: '10px', textAlign: 'center' }}>[ LOOKBOOK ]</h1>
        <p style={{ fontSize: '12px', color: '#4C956C', marginBottom: '40px', textAlign: 'center' }}>CURATED COLLECTIONS FOR THE COURSE</p>
        
        {collections.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <p style={{ fontSize: '14px', color: '#4C956C', marginBottom: '10px' }}>NO COLLECTIONS YET</p>
            <p style={{ fontSize: '12px', color: '#999' }}>Collections will appear here once created in the admin panel</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>
            {collections.map((collection) => (
              <div
                key={collection._id}
                className="retro-card"
                style={{ background: '#FFF', padding: '0', overflow: 'hidden', cursor: 'pointer' }}
                onClick={() => handleCollectionClick(collection._id)}
              >
                <div style={{ background: collection.banner_color || '#2C6E49', padding: '30px', textAlign: 'center' }}>
                  <div style={{ fontSize: '48px', marginBottom: '10px' }}>
                    {collection.emoji_icons?.join(' ') || '⛳'}
                  </div>
                  <h2 style={{ fontSize: '20px', color: '#FEFEE3', marginBottom: '5px' }}>{collection.name}</h2>
                  <p style={{ fontSize: '12px', color: '#FFC857' }}>{collection.season}</p>
                </div>
                
                <div style={{ padding: '30px' }}>
                  <p style={{ fontSize: '14px', color: '#4B4B4B', marginBottom: '20px', lineHeight: '1.6' }}>{collection.description}</p>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ fontSize: '12px', color: '#4C956C' }}>{collection.product_ids?.length || 0} PIECES</p>
                    <div className="retro-btn" style={{ background: '#2C6E49', color: '#FEFEE3', padding: '12px 30px', fontSize: '12px' }}>
                      EXPLORE >>>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <BottomNav currentPath="/lookbook" />
    </div>
  );
};

export default Lookbook;
